import { Tabs } from "antd";
import React from "react";

export const TabsUi = ({ data, ...props }) => {
  return <Tabs items={data} {...props}></Tabs>;
};
